import React from 'react';
import YouTube from 'react-youtube';

import Icon from 'Core/Components/Icon';
import Events from 'Core/Utils/Events';
import { autoWidth, autoFactor, colWidth, currentBreakpoint } from 'Core/Utils/BreakPoints';

const ASPECT_RATIO = 0.625;

class ResponsiveVideo extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      width: autoWidth(),
      height: autoFactor(ASPECT_RATIO)
    };

    this.componentDidMount = this.componentDidMount.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  updateDimensions () {
    let width = autoWidth();
    let height = autoFactor(ASPECT_RATIO);
    this.setState({ height, width });
  }

  componentDidMount () {
    this.listener = Events.add('resize', this.updateDimensions);
  }

  componentWillUnmount () {
    Events.remove(this.listener);
  }

  switchToVideo (video, activeIndex) {
    this.setState({ activeIndex });
  }

  render () {
    const { id, widthOffset, heightOffset, children } = this.props;
    const { height, width } = this.state;
    const adjustedHeight = height + (typeof heightOffset === 'number' ? heightOffset : 0);
    const adjustedWidth = width + (typeof widthOffset === 'number' ? widthOffset : 0);

    return !id ? null : (
      <div className="ResponsiveVideo">
        <YouTube videoId={id} className="player" opts={{ height: adjustedHeight, width: adjustedWidth }} />
        {children ? <div className="ResponsiveVideo-Children" children={children} /> : null}
      </div>
    );
  }
};

export default ResponsiveVideo;



// WEBPACK FOOTER //
// ./client/Site/Ui/ResponsiveVideo.jsx